export default '2.9.0-20240129'



// WEBPACK FOOTER //
// ./src/dd_version.js